import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

export const bankingBankSave: TypedDocumentNode<
    Pick<GQL.IMutation, "bankingBankSave">,
    GQL.IMutationBankingBankSaveArgs
> = gql`
    mutation bankingBankSave($input: BankSaveInput!) {
        bankingBankSave(input: $input) {
            id
        }
    }
`;

export const bankingBankDelete: TypedDocumentNode<
    Pick<GQL.IMutation, "bankingBankDelete">,
    GQL.IMutationBankingBankDeleteArgs
> = gql`
    mutation bankingBankDelete($input: IDCompanyIDInput!) {
        bankingBankDelete(input: $input)
    }
`;

export const bankingBankAccountingBind: TypedDocumentNode<
    Pick<GQL.IMutation, "bankingBankAccountingBind">,
    GQL.IMutationBankingBankAccountingBindArgs
> = gql`
    mutation bankingBankAccountingBind($input: AccountingBindInput!) {
        bankingBankAccountingBind(input: $input) {
            id
            accountingBankId
        }
    }
`;

export const bankingBankMarkFavorite: TypedDocumentNode<
    Pick<GQL.IMutation, "bankingBankMarkFavorite">,
    GQL.IMutationBankingBankMarkFavoriteArgs
> = gql`
    mutation bankingBankMarkFavorite($input: IDCompanyIDInput!) {
        bankingBankMarkFavorite(input: $input)
    }
`;

export const bankingTransactionsCreate: TypedDocumentNode<
    Pick<GQL.IMutation, "bankingTransactionsCreate">,
    GQL.IMutationBankingTransactionsCreateArgs
> = gql`
    mutation bankingTransactionCreate($companyId: ID!, $bankId: ID!, $input: [TransactionCreateInput!]!) {
        bankingTransactionsCreate(companyId: $companyId, bankId: $bankId, input: $input)
    }
`;

export const bankingTransactionsUpdate: TypedDocumentNode<
    Pick<GQL.IMutation, "bankingTransactionsUpdate">,
    GQL.IMutationBankingTransactionsUpdateArgs
> = gql`
    mutation transactionsUpdate($companyId: ID!, $bankId: ID!, $input: [TransactionUpdateInput!]!) {
        bankingTransactionsUpdate(companyId: $companyId, bankId: $bankId, input: $input)
    }
`;

export const bankingTransactionsDelete: TypedDocumentNode<
    Pick<GQL.IMutation, "bankingTransactionsDelete">,
    GQL.IMutationBankingTransactionsDeleteArgs
> = gql`
    mutation transactionsDelete($ids: IDsCompanyIDInput!, $bankId: ID!) {
        bankingTransactionsDelete(ids: $ids, bankId: $bankId)
    }
`;

export const bankingTransactionsMatchContacts: TypedDocumentNode<
    Pick<GQL.IMutation, "bankingTransactionsMatchContacts">,
    GQL.IMutationBankingTransactionsMatchContactsArgs
> = gql`
    mutation bankingTransactionsMatchContacts($companyId: ID!, $transactionIds: [ID!]!) {
        bankingTransactionsMatchContacts(companyId: $companyId, transactionIds: $transactionIds) {
            transactionId
            outcome
            contactId
            rule
        }
    }
`;

export const bankingTransactionsCreateContacts: TypedDocumentNode<
    Pick<GQL.IMutation, "bankingTransactionsCreateContacts">,
    GQL.IMutationBankingTransactionsCreateContactsArgs
> = gql`
    mutation bankingTransactionsCreateContacts($companyId: ID!, $vatIds: [String!]!, $transactionIds: [ID!]) {
        bankingTransactionsCreateContacts(companyId: $companyId, vatIds: $vatIds, transactionIds: $transactionIds) {
            vatId
            outcome
            contactId
            linkedTransactionIds
        }
    }
`;

export const bankingTransactionsFindDocuments: TypedDocumentNode<
    Pick<GQL.IMutation, "bankingTransactionsFindDocuments">,
    GQL.IMutationBankingTransactionsFindDocumentsArgs
> = gql`
    mutation bankingTransactionsFindDocuments($input: BankingTransactionsFindDocumentsInput!) {
        bankingTransactionsFindDocuments(input: $input) {
            id
            candidates {
                id
                documentIds
                confidence
                evidence
                tier
            }
        }
    }
`;

export const bankingTransactionSetDmsDocumentIds: TypedDocumentNode<
    Pick<GQL.IMutation, "bankingTransactionSetDmsDocumentIds">,
    GQL.IMutationBankingTransactionSetDmsDocumentIdsArgs
> = gql`
    mutation bankingTransactionSetDmsDocumentIds(
        $id: IDCompanyIDInput!
        $bankId: ID!
        $documents: [EntityDocumentIdInput!]!
    ) {
        bankingTransactionSetDmsDocumentIds(id: $id, bankId: $bankId, documents: $documents)
    }
`;

export const transactionsExportToRecords: TypedDocumentNode<
    Pick<GQL.IMutation, "transactionsExportToRecords">,
    GQL.IMutationTransactionsExportToRecordsArgs
> = gql`
    mutation transactionsExportToRecords(
        $companyId: ID!
        $kind: TransactionExportKind!
        $transactionIds: [ID!]!
        $force: Boolean
    ) {
        transactionsExportToRecords(
            companyId: $companyId
            kind: $kind
            transactionIds: $transactionIds
            force: $force
        ) {
            transactionId
            outcome
            recordId
            message
        }
    }
`;

export const bankingFillBank: TypedDocumentNode<
    Pick<GQL.IMutation, "bankingFillBank">,
    GQL.IMutationBankingFillBankArgs
> = gql`
    mutation bankingFillBank($companyId: ID!, $action: FillBankAction!, $recordKeys: [ID!]!) {
        bankingFillBank(companyId: $companyId, action: $action, recordKeys: $recordKeys) {
            transactionId
            outcome
            candidates
            recordIds
        }
    }
`;

export const accountReconciliationApply: TypedDocumentNode<
    Pick<GQL.IMutation, "accountReconciliationApply">,
    GQL.IMutationAccountReconciliationApplyArgs
> = gql`
    mutation accountReconciliationApply(
        $companyId: ID!
        $konto: String!
        $mode: ReconciliationMode!
        $key: ReconciliationKey
        $groupIds: [ID!]!
        $idempotencyKey: ID!
    ) {
        accountReconciliationApply(
            companyId: $companyId
            konto: $konto
            mode: $mode
            key: $key
            groupIds: $groupIds
            idempotencyKey: $idempotencyKey
        ) {
            groupId
            outcome
            message
        }
    }
`;
